import { useState, useMemo } from 'react';

/**
 * @deprecated
 * Ora il componente non fa nulla!!!!
 * Verrà rimosso con la prossima versione.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function useTooltipHoverWithDelay(delay = 1000) {
    const [show, setShow] = useState(false);
    const [onMouseEnter, onMouseLeave] = useMemo(() => [
        () => { setShow(true); },
        () => { setShow(false); },
    ], []);
    return [show, onMouseEnter, onMouseLeave];
}

export { useTooltipHoverWithDelay as default };
